import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {IconButton} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import logo from '../kaf-logo-small-yellow.png'
import useCheckMobileScreen from '../utils/detect-mobile-size';

export default function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const isMobile = useCheckMobileScreen();

    const [isPaymentPage, setIsPaymentPage] = useState(false);

    useEffect(() => {
        if(location.pathname === "/payment") {
            setIsPaymentPage(true);
        } else {
            setIsPaymentPage(false);
        }
    }, [location]);



    return (
        <div className="header">
            <div className="flex flex-1 items-center">
                {isPaymentPage && <a onClick={() => navigate(-1)} className="text-primary-500"><IconButton color="secondary"><ArrowBack /></IconButton></a>}
                <Link to={'/'}>
                    {isMobile ?
                        <img className="px-4 object-contain h-10" alt="icon" src={logo} />
                        :
                        <img className="px-4 object-contain h-16" alt="logo" src={logo} />
                    }
                </Link>
            </div>

            {isMobile &&
                <h2 className="flex justify-center content-center flex-1 text-xl font-semibold">
                    {isPaymentPage ? <>Afrekenen</> : <>Menu</>}
                </h2>
            }
            <div className="flex-1"></div>
        </div>
    )
}